/**
 * Generated With: pnpm x packages/api/tools/generate-shopify-rest-model.ts https://shopify.dev/api/admin/rest/reference/customers/customer
 * API Version: 2022-01
 */

import { FieldType } from "../../type-system/FieldType";
import { shopifyTaxExemptionsEnumOptions } from "./constants";
import {
  ShopifyCheckoutKey,
  ShopifyCheckoutToCustomerKey,
  ShopifyCompanyContactKey,
  ShopifyCompanyContactToCustomerKey,
  ShopifyCustomerAddressKey,
  ShopifyCustomerAddressToCustomerKey,
  ShopifyCustomerKey,
  ShopifyCustomerMergeableKey,
  ShopifyCustomerMergeableToCustomerKey,
  ShopifyCustomerOwnerToStoreCreditAccountsKey,
  ShopifyCustomerPaymentMethodKey,
  ShopifyCustomerPaymentMethodToCustomerKey,
  ShopifyCustomerToCheckoutsKey,
  ShopifyCustomerToCompanyContactsKey,
  ShopifyCustomerToCustomerAddressesKey,
  ShopifyCustomerToDraftOrdersKey,
  ShopifyCustomerToGiftCardsKey,
  ShopifyCustomerToMarketKey,
  ShopifyCustomerToOrderKey,
  ShopifyCustomerToShopKey,
  ShopifyCustomerToStoreCreditAccountsKey,
  ShopifyCustomerToSubscriptionContractsKey,
  ShopifyDraftOrderKey,
  ShopifyDraftOrderToCustomerKey,
  ShopifyGiftCardKey,
  ShopifyGiftCardToCustomerKey,
  ShopifyMarketKey,
  ShopifyOrderKey,
  ShopifyOrderToCustomerKey,
  ShopifyShopKey,
  ShopifyStoreCreditAccountKey,
  ShopifyStoreCreditAccountToCustomerKey,
  ShopifyStoreCreditAccountToCustomerOwnerKey,
  ShopifySubscriptionContractKey,
  ShopifySubscriptionContractToCustomerKey,
} from "./keys";
import type { ShopifyApiVersion } from "./ShopifyApiVersion";
import { ShopifyDominion } from "./ShopifyDominion";
import type { ConnectionModelSpecVersion } from "./ShopifyMetadata";
import { buildConnectionSpec } from "./ShopifyMetadata";

// we removed graphql only fields from the model spec which changes how the static keys are generated. these are here so that they remain the same
const statisticsKey = "ModelField-DataModel-Shopify-Customer-__gadget_graphql_customer_statistics";
const statisticsStorageEpochKey = "FieldStorageEpoch-DataModel-Shopify-Customer-__gadget_graphql_customer_statistics-initial";
const mergeableKey = "ModelField-DataModel-Shopify-Customer-__gadget_graphql_customer_mergeable";
const mergeableStorageEpochKey = "FieldStorageEpoch-DataModel-Shopify-Customer-__gadget_graphql_customer_mergeable-initial";
const localeKey = "ModelField-DataModel-Shopify-Customer-__gadget_graphql_locale";
const localeStorageEpochKey = "FieldStorageEpoch-DataModel-Shopify-Customer-__gadget_graphql_locale-initial";

const specs: ConnectionModelSpecVersion = {
  key: ShopifyCustomerKey,
  "2022-01": {
    name: "Shopify Customer",
    graphQLTypename: "Customer",
    hasMetafields: true,
    fields: [
      {
        name: "Accepts Marketing",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "accepts_marketing" } },
      },
      {
        name: "Accepts Marketing Updated At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "accepts_marketing_updated_at" } },
      },
      {
        name: "Addresses",
        fieldType: FieldType.HasMany,
        key: ShopifyCustomerToCustomerAddressesKey,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "addresses" } },
        configuration: {
          relatedModelKey: ShopifyCustomerAddressKey,
          inverseFieldKey: ShopifyCustomerAddressToCustomerKey,
        },
      },
      {
        name: "Currency",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "currency" } },
      },
      {
        name: "Default Address",
        fieldType: FieldType.BelongsTo,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "default_address" } },
        configuration: {
          relatedModelKey: ShopifyCustomerAddressKey,
        },
      },
      {
        name: "Email",
        fieldType: FieldType.Email,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "email" } },
      },
      {
        name: "First Name",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "first_name" } },
      },
      {
        name: "Gift Cards",
        fieldType: FieldType.HasMany,
        key: ShopifyCustomerToGiftCardsKey,
        configuration: {
          relatedModelKey: ShopifyGiftCardKey,
          inverseFieldKey: ShopifyGiftCardToCustomerKey,
        },
      },
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "id" } },
      },
      {
        name: "Last Name",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "last_name" } },
      },
      {
        name: "Last Order",
        fieldType: FieldType.BelongsTo,
        key: ShopifyCustomerToOrderKey,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "last_order_id" } },
        configuration: {
          relatedModelKey: ShopifyOrderKey,
        },
      },
      {
        name: "Last Order Name",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "last_order_name" } },
      },
      {
        name: "Marketing Opt In Level",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "marketing_opt_in_level" } },
      },
      {
        name: "Metafield",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "metafield" } },
      },
      {
        name: "Multipass Identifier",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "multipass_identifier" } },
      },
      {
        name: "Note",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "note" } },
      },
      {
        name: "Orders",
        fieldType: FieldType.HasMany,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "orders" } },
        configuration: {
          relatedModelKey: ShopifyOrderKey,
          inverseFieldKey: ShopifyOrderToCustomerKey,
        },
      },
      {
        name: "Draft Orders",
        fieldType: FieldType.HasMany,
        key: ShopifyCustomerToDraftOrdersKey,
        configuration: {
          relatedModelKey: ShopifyDraftOrderKey,
          inverseFieldKey: ShopifyDraftOrderToCustomerKey,
        },
      },
      {
        name: "Orders Count",
        fieldType: FieldType.Number,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "orders_count" } },
      },
      {
        name: "Payment Methods",
        fieldType: FieldType.HasMany,
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "paymentMethods" } },
        configuration: {
          dependent: "delete",
          relatedModelKey: ShopifyCustomerPaymentMethodKey,
          inverseFieldKey: ShopifyCustomerPaymentMethodToCustomerKey,
        },
      },
      {
        name: "Phone",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "phone" } },
      },
      {
        name: "Shopify Created At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "created_at", graphQLFieldKey: "createdAt" },
        },
      },
      {
        name: "Shopify Updated At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "updated_at", graphQLFieldKey: "updatedAt" },
        },
      },
      {
        name: "Subscription Contracts",
        fieldType: FieldType.HasMany,
        key: ShopifyCustomerToSubscriptionContractsKey,
        configuration: {
          relatedModelKey: ShopifySubscriptionContractKey,
          inverseFieldKey: ShopifySubscriptionContractToCustomerKey,
        },
      },
      {
        name: "Tags",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "tags" } },
      },
      {
        name: "Tax Exempt",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "tax_exempt" } },
      },
      {
        name: "Tax Exemptions",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "tax_exemptions" } },
      },
      {
        name: "Total Spent",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "total_spent" } },
      },
      {
        name: "Verified Email",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "verified_email" } },
      },
      {
        name: "Checkouts",
        fieldType: FieldType.HasMany,
        key: ShopifyCustomerToCheckoutsKey,
        configuration: {
          relatedModelKey: ShopifyCheckoutKey,
          inverseFieldKey: ShopifyCheckoutToCustomerKey,
        },
      },
      {
        name: "Shop",
        fieldType: FieldType.BelongsTo,
        key: ShopifyCustomerToShopKey,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "shop_id" } },
        configuration: {
          relatedModelKey: ShopifyShopKey,
        },
      },
    ],
    syncConfig: { type: "rest_list", resource: "customer" },
  },
  "2022-04": {
    fields: [
      {
        name: "Email Marketing Consent",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "email_marketing_consent" } },
      },
      {
        name: "SMS Marketing Consent",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "sms_marketing_consent" } },
      },
      {
        name: "Accepts Marketing",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "accepts_marketing", deprecated: true },
        },
      },
      {
        name: "Accepts Marketing Updated At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "accepts_marketing_updated_at", deprecated: true },
        },
      },
      {
        name: "Marketing Opt In Level",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "marketing_opt_in_level", deprecated: true },
        },
      },
      {
        name: "Shopify State",
        fieldType: FieldType.Enum,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "state" } },
        configuration: {
          allowOther: true,
          allowMultiple: false,
          options: [{ name: "DISABLED" }, { name: "INVITED" }, { name: "ENABLED" }, { name: "DECLINED" }],
        },
      },
    ],
  },
  "2022-07": {
    fields: [
      {
        name: "Statistics",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "__gadget_graphql_customer_statistics",
            graphQLFieldKey: "statistics",
            graphQLOnlyField: true,
            graphQLSelection: `predictedSpendTier`,
          },
        },
      },
    ],
  },
  "2023-04": {
    fields: [
      {
        name: "Company Contacts",
        fieldType: FieldType.HasMany,
        key: ShopifyCustomerToCompanyContactsKey,
        configuration: {
          relatedModelKey: ShopifyCompanyContactKey,
          inverseFieldKey: ShopifyCompanyContactToCustomerKey,
        },
      },
    ],
  },
  "2023-07": {
    fields: [
      {
        name: "Mergeable",
        fieldType: FieldType.HasOne,
        configuration: {
          relatedModelKey: ShopifyCustomerMergeableKey,
          inverseFieldKey: ShopifyCustomerMergeableToCustomerKey,
        },
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "__gadget_graphql_customer_mergeable",
            graphQLFieldKey: "mergeable",
            graphQLOnlyField: true,
            graphQLSelection: `
            isMergeable
            reason
          mergeInProgress {
              jobId
              resultingCustomerId
              status
              customerMergeErrors {
                message
                errorFields
              }
            }
            errorFields
            `,
          },
        },
      },
    ],
  },
  "2024-01": {
    fields: [
      {
        name: "Locale",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "__gadget_graphql_locale",
            graphQLFieldKey: "locale",
            graphQLOnlyField: true,
          },
        },
      },
    ],
  },
  "2024-07": {
    fields: [
      {
        name: "Data Sale Opt Out",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "__gadget_graphql_data_sale_opt_out",
            graphQLFieldKey: "dataSaleOptOut",
            graphQLOnlyField: true,
          },
        },
      },
      {
        name: "Store Credit Accounts",
        fieldType: FieldType.HasMany,
        key: ShopifyCustomerToStoreCreditAccountsKey,
        configuration: {
          relatedModelKey: ShopifyStoreCreditAccountKey,
          inverseFieldKey: ShopifyStoreCreditAccountToCustomerKey,
        },
      },
    ],
  },
  "2025-04": {
    fields: [
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "id",
            graphQLFieldKey: "id",
            availableInWebhook: [
              "customers/create",
              "customers/update",
              "draft_orders/create",
              "draft_orders/update",
              "orders/create",
              "orders/updated",
            ],
          },
        },
      },
      {
        name: "Shopify Created At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "created_at",
            graphQLFieldKey: "createdAt",
            availableInWebhook: [
              "customers/create",
              "customers/update",
              "draft_orders/create",
              "draft_orders/update",
              "orders/create",
              "orders/updated",
            ],
          },
        },
      },
      {
        name: "Shopify Updated At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "updated_at",
            graphQLFieldKey: "updatedAt",
            availableInWebhook: [
              "customers/create",
              "customers/update",
              "draft_orders/create",
              "draft_orders/update",
              "orders/create",
              "orders/updated",
            ],
          },
        },
      },
      {
        name: "Accepts Marketing",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "accepts_marketing",
            deprecated: true,
            availableInWebhook: ["draft_orders/create", "draft_orders/update", "orders/create", "orders/updated"],
          },
        },
      },
      {
        name: "Accepts Marketing Updated At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "accepts_marketing_updated_at",
            deprecated: true,
            availableInWebhook: ["draft_orders/create", "draft_orders/update", "orders/create", "orders/updated"],
          },
        },
      },
      {
        name: "Addresses",
        fieldType: FieldType.HasMany,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "addresses",
            availableInWebhook: ["customers/create", "customers/update"],
          },
        },
        configuration: {
          relatedModelKey: ShopifyCustomerAddressKey,
          inverseFieldKey: ShopifyCustomerAddressToCustomerKey,
        },
      },
      {
        name: "Currency",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "currency",
            availableInWebhook: [
              "customers/create",
              "customers/update",
              "draft_orders/create",
              "draft_orders/update",
              "orders/create",
              "orders/updated",
            ],
            graphQLFieldKey: "currency",
            skipGraphQLSelection: true,
            deprecated: true,
          },
        },
      },
      {
        name: "Default Address",
        fieldType: FieldType.BelongsTo,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "default_address",
            availableInWebhook: [
              "customers/create",
              "customers/update",
              "draft_orders/create",
              "draft_orders/update",
              "orders/create",
              "orders/updated",
            ],
          },
        },
        configuration: {
          relatedModelKey: ShopifyCustomerAddressKey,
        },
      },
      {
        name: "Email",
        fieldType: FieldType.Email,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "email",
            availableInWebhook: [
              "customers/create",
              "customers/update",
              "draft_orders/create",
              "draft_orders/update",
              "orders/create",
              "orders/updated",
            ],
            graphQLFieldKey: "email",
            protectedCustomerData: ["email"],
          },
        },
      },
      {
        name: "First Name",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "first_name",
            availableInWebhook: [
              "customers/create",
              "customers/update",
              "draft_orders/create",
              "draft_orders/update",
              "orders/create",
              "orders/updated",
            ],
            graphQLFieldKey: "firstName",
            protectedCustomerData: ["name"],
          },
        },
      },
      {
        name: "Gift Cards",
        fieldType: FieldType.HasMany,
        key: ShopifyCustomerToGiftCardsKey,
        configuration: {
          relatedModelKey: ShopifyGiftCardKey,
          inverseFieldKey: ShopifyGiftCardToCustomerKey,
        },
      },
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "id",
            availableInWebhook: ["customers/create", "draft_orders/create", "orders/create"],
            graphQLFieldKey: "id",
          },
        },
      },
      {
        name: "Last Name",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "last_name",
            graphQLFieldKey: "lastName",
            availableInWebhook: [
              "customers/create",
              "customers/update",
              "draft_orders/create",
              "draft_orders/update",
              "orders/create",
              "orders/updated",
            ],
            protectedCustomerData: ["name"],
          },
        },
      },
      {
        name: "Last Order",
        fieldType: FieldType.BelongsTo,
        key: ShopifyCustomerToOrderKey,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            availableInWebhook: ["draft_orders/create", "draft_orders/update"],
            shopifyFieldKey: "last_order_id",
            graphQLFieldKey: "lastOrder",
            graphQLSelection: `
            id
            name
            `,
          },
        },
        configuration: {
          relatedModelKey: ShopifyOrderKey,
        },
      },
      {
        name: "Last Order Name",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "last_order_name",
            graphQLFieldKey: "lastOrderName",
            skipGraphQLSelection: true,
            availableInWebhook: ["draft_orders/create", "draft_orders/update"],
          },
        },
      },
      {
        name: "Marketing Opt In Level",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "marketing_opt_in_level",
            deprecated: true,
            availableInWebhook: ["draft_orders/create", "draft_orders/update", "orders/create", "orders/updated"],
          },
        },
      },
      {
        name: "Metafield",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "metafield" } },
        isDeleted: true,
      },
      {
        name: "Multipass Identifier",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "multipass_identifier",
            availableInWebhook: [
              "customers/create",
              "customers/update",
              "draft_orders/create",
              "draft_orders/update",
              "orders/create",
              "orders/updated",
            ],
            graphQLFieldKey: "multipassIdentifier",
          },
        },
      },
      {
        name: "Note",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "note",
            availableInWebhook: [
              "customers/create",
              "customers/update",
              "draft_orders/create",
              "draft_orders/update",
              "orders/create",
              "orders/updated",
            ],
            graphQLFieldKey: "note",
          },
        },
      },
      {
        name: "Orders",
        fieldType: FieldType.HasMany,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "orders" } },
        configuration: {
          relatedModelKey: ShopifyOrderKey,
          inverseFieldKey: ShopifyOrderToCustomerKey,
        },
      },
      {
        name: "Draft Orders",
        fieldType: FieldType.HasMany,
        key: ShopifyCustomerToDraftOrdersKey,
        configuration: {
          relatedModelKey: ShopifyDraftOrderKey,
          inverseFieldKey: ShopifyDraftOrderToCustomerKey,
        },
      },
      {
        name: "Orders Count",
        fieldType: FieldType.Number,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "orders_count", availableInWebhook: ["customers/create"] },
        },
        isDeleted: true,
      },
      {
        name: "Number Of Orders",
        fieldType: FieldType.Number,
        contributorConfiguration: {
          [ShopifyDominion.id]: { graphQLFieldKey: "numberOfOrders" },
        },
      },
      {
        name: "Payment Methods",
        fieldType: FieldType.HasMany,
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "paymentMethods" } },
        configuration: {
          dependent: "delete",
          relatedModelKey: ShopifyCustomerPaymentMethodKey,
          inverseFieldKey: ShopifyCustomerPaymentMethodToCustomerKey,
        },
      },
      {
        name: "Phone",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "phone",
            availableInWebhook: [
              "customers/create",
              "customers/update",
              "draft_orders/create",
              "draft_orders/update",
              "orders/create",
              "orders/updated",
            ],
            graphQLFieldKey: "phone",
            protectedCustomerData: ["phone"],
          },
        },
      },
      {
        name: "Subscription Contracts",
        fieldType: FieldType.HasMany,
        key: ShopifyCustomerToSubscriptionContractsKey,
        configuration: {
          relatedModelKey: ShopifySubscriptionContractKey,
          inverseFieldKey: ShopifySubscriptionContractToCustomerKey,
        },
      },
      {
        name: "Tags",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "tags",
            graphQLFieldKey: "tags",
            availableInWebhook: ["draft_orders/create", "draft_orders/update", "orders/create", "orders/updated"],
          },
        },
      },
      {
        name: "Tax Exempt",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "tax_exempt",
            graphQLFieldKey: "taxExempt",
            availableInWebhook: [
              "customers/create",
              "customers/update",
              "draft_orders/create",
              "draft_orders/update",
              "orders/create",
              "orders/updated",
            ],
          },
        },
      },
      {
        name: "Tax Exemptions",
        fieldType: FieldType.Enum,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "tax_exemptions",
            graphQLFieldKey: "taxExemptions",
            isShopifyEnum: true,
            availableInWebhook: [
              "customers/create",
              "customers/update",
              "draft_orders/create",
              "draft_orders/update",
              "orders/create",
              "orders/updated",
            ],
          },
        },
        configuration: {
          allowMultiple: true,
          allowOther: true,
          options: shopifyTaxExemptionsEnumOptions,
        },
      },
      {
        name: "Total Spent",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "total_spent", availableInWebhook: ["customers/create"] },
        },
        isDeleted: true,
      },
      {
        name: "Verified Email",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "verified_email",
            graphQLFieldKey: "verifiedEmail",
            availableInWebhook: [
              "customers/create",
              "customers/update",
              "draft_orders/create",
              "draft_orders/update",
              "orders/create",
              "orders/updated",
            ],
          },
        },
      },
      {
        name: "Checkouts",
        fieldType: FieldType.HasMany,
        key: ShopifyCustomerToCheckoutsKey,
        configuration: {
          relatedModelKey: ShopifyCheckoutKey,
          inverseFieldKey: ShopifyCheckoutToCustomerKey,
        },
      },
      {
        name: "Email Marketing Consent",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "email_marketing_consent",
            graphQLFieldKey: "emailMarketingConsent",
            graphQLSelection: `
            marketingState
            marketingOptInLevel
            consentUpdatedAt`,
            availableInWebhook: ["draft_orders/create", "draft_orders/update", "orders/create", "orders/updated"],
          },
        },
      },
      {
        name: "SMS Marketing Consent",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "sms_marketing_consent",
            availableInWebhook: ["draft_orders/create", "draft_orders/update", "orders/create", "orders/updated"],
            graphQLFieldKey: "smsMarketingConsent",
            graphQLSelection: `
            marketingState
            marketingOptInLevel
            consentUpdatedAt`,
          },
        },
      },
      {
        name: "Shopify State",
        fieldType: FieldType.Enum,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "state",
            graphQLFieldKey: "state",
            isShopifyEnum: true,
            availableInWebhook: [
              "customers/create",
              "customers/update",
              "draft_orders/create",
              "draft_orders/update",
              "orders/create",
              "orders/updated",
            ],
          },
        },
        configuration: {
          allowOther: true,
          allowMultiple: false,
          options: [{ name: "DISABLED" }, { name: "INVITED" }, { name: "ENABLED" }, { name: "DECLINED" }],
        },
      },
      {
        name: "Statistics",
        key: statisticsKey,
        initialStorageEpochKey: statisticsStorageEpochKey,
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "statistics",
            graphQLSelection: `
            predictedSpendTier
            rfmGroup
            `,
          },
        },
      },
      {
        name: "Company Contacts",
        fieldType: FieldType.HasMany,
        key: ShopifyCustomerToCompanyContactsKey,
        configuration: {
          relatedModelKey: ShopifyCompanyContactKey,
          inverseFieldKey: ShopifyCompanyContactToCustomerKey,
        },
      },
      {
        name: "Mergeable",
        key: mergeableKey,
        initialStorageEpochKey: mergeableStorageEpochKey,
        fieldType: FieldType.HasOne,
        configuration: {
          relatedModelKey: ShopifyCustomerMergeableKey,
          inverseFieldKey: ShopifyCustomerMergeableToCustomerKey,
        },
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "mergeable",
            graphQLSelection: `
            isMergeable
            reason
          mergeInProgress {
              jobId
              resultingCustomerId
              status
              customerMergeErrors {
                message
                errorFields
              }
            }
            errorFields
            `,
          },
        },
      },
      {
        name: "Locale",
        key: localeKey,
        initialStorageEpochKey: localeStorageEpochKey,
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "locale",
          },
        },
      },
      {
        name: "Amount Spent",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "amountSpent",
            graphQLSelection: `
            currencyCode
            amount`,
          },
        },
      },
      {
        name: "Can Delete",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "canDelete" } },
      },
      {
        name: "Display Name",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "displayName",
            protectedCustomerData: ["name"],
          },
        },
      },
      {
        name: "Legacy Resource Id",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "legacyResourceId",
          },
        },
      },
      {
        name: "Lifetime Duration",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "lifetimeDuration",
          },
        },
      },
      {
        name: "Locale",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "locale",
          },
        },
      },
      {
        name: "Market",
        key: ShopifyCustomerToMarketKey,
        fieldType: FieldType.BelongsTo,
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "market", graphQLSelection: "id", deprecated: true } },
        configuration: {
          relatedModelKey: ShopifyMarketKey,
        },
      },
      {
        name: "Product Subscriber Status",
        fieldType: FieldType.Enum,
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "productSubscriberStatus", isShopifyEnum: true } },
        configuration: {
          allowOther: true,
          allowMultiple: false,
          options: [
            { name: "ACTIVE" },
            { name: "CANCELLED" },
            { name: "EXPIRED" },
            { name: "FAILED" },
            { name: "NEVER_SUBSCRIBED" },
            { name: "PAUSED" },
          ],
        },
      },
      {
        name: "Unsubscribe Url",
        fieldType: FieldType.URL,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "unsubscribeUrl",
          },
        },
      },
      {
        name: "Valid Email Address",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "validEmailAddress" } },
      },
      {
        name: "Has Timeline Comment",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "hasTimelineComment", deprecated: true } },
      },
    ],
    syncConfig: {
      type: "graphql_list",
      resource: "customers",
      filters: {
        updatedAt: { sortKey: "UPDATED_AT" },
      },
      sortableBy: {
        updatedAt: { sortKey: "UPDATED_AT", reverse: true },
        createdAt: { sortKey: "CREATED_AT", reverse: true },
        id: { sortKey: "ID", reverse: false },
        location: { sortKey: "LOCATION", reverse: false },
        name: { sortKey: "NAME", reverse: false },
        relevance: { sortKey: "RELEVANCE", reverse: false },
      },
    },
  },
  "2025-10": {
    fields: [
      {
        name: "Store Credit Accounts",
        fieldType: FieldType.HasMany,
        key: ShopifyCustomerToStoreCreditAccountsKey,
        configuration: {
          relatedModelKey: ShopifyStoreCreditAccountKey,
          inverseFieldKey: ShopifyStoreCreditAccountToCustomerKey,
        },
        isDeleted: true,
      },
      {
        name: "Customer Store Credit Accounts",
        fieldType: FieldType.HasMany,
        key: ShopifyCustomerOwnerToStoreCreditAccountsKey,
        configuration: {
          relatedModelKey: ShopifyStoreCreditAccountKey,
          inverseFieldKey: ShopifyStoreCreditAccountToCustomerOwnerKey,
        },
      },
    ],
  },
};

export const ShopifyCustomer = ({
  apiVersion,
  frameworkVersionConstraint,
  webhookTopicsForModel,
}: {
  apiVersion: ShopifyApiVersion;
  frameworkVersionConstraint?: string;
  webhookTopicsForModel?: string[];
}) => buildConnectionSpec(specs, apiVersion, frameworkVersionConstraint, webhookTopicsForModel);
